import React, { useState, useEffect } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { useSelector } from "react-redux";
import axios from "axios";
import styled from "styled-components";

const RatingsReviewsTab = ({ partnerId }) => {
  const [activeTab, setActiveTab] = useState("reviews");
  const [ratings, setRatings] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const { AuthReducer: { auth } } = useSelector((state) => state);

  useEffect(() => {
    fetchPartnerRatings();
    fetchPartnerPhotos();
  }, [partnerId]);

  const fetchPartnerRatings = async () => {
    try {
      const response = await axios.get(`/api/admin/v1/partner-ratings/${partnerId}`, {
        headers: { Authorization: `Bearer ${auth?.token}` }
      });
      setRatings(response.data.ratings || []);
    } catch (error) {
      console.error('Failed to fetch partner ratings');
    } finally {
      setLoading(false);
    }
  };

  const fetchPartnerPhotos = async () => {
    try {
      const response = await axios.get(`/api/admin/v1/partner-photos/${partnerId}`, {
        headers: { Authorization: `Bearer ${auth?.token}` }
      });
      setPhotos(response.data.photos || []);
    } catch (error) {
      console.error('Failed to fetch partner photos');
    }
  };

  return (
    <Wrapper>
      <div className="card border-0 shadow-sm p-4">
        <h4 className="fw-bold text-dark">Ratings & Reviews</h4>
        <p className="text-muted mb-4">
          See what users are saying and sharing about this partner's tourist spots.
        </p>
        <div className="d-flex mb-4">
          <button
            className={`btn me-2 border ${activeTab === "reviews" ? "btn-primary text-white" : "btn-light"}`}
            onClick={() => setActiveTab("reviews")}
          >
            All Reviews
          </button>
          <button
            className={`btn border ${activeTab === "photos" ? "btn-primary text-white" : "btn-light"}`}
            onClick={() => setActiveTab("photos")}
          >
            User Photos
          </button>
        </div>
        
        {activeTab === "reviews" && ratings.map((rating, idx) => (
          <div className="card p-3 shadow-sm border-0 mb-3" key={idx}>
            <div className="d-flex justify-content-between">
              <div>
                <div className="d-flex align-items-start mb-3">
                  <div
                    className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center me-2"
                    style={{ width: "35px", height: "35px", fontSize: "14px" }}
                  >
                    {rating.user?.name ? rating.user.name.substring(0, 2).toUpperCase() : 'AN'}
                  </div>
                  <div>
                    <div className="fw-bold text-dark">{rating.user?.name || 'Anonymous'}</div>
                    <div className="text-muted small">Reviewed on {new Date(rating.createdAt).toLocaleDateString()}</div>
                  </div>
                </div>
                <div className="fw-semibold text-dark">Spot: {rating.place?.place_name || 'N/A'}</div>
                <p className="text-muted mb-2">{rating.comment}</p>
                {rating.images && (
                  <button className="btn btn-outline-primary btn-sm">📷 Photo included</button>
                )}
              </div>
              <div className="text-end">
                {[...Array(rating.rating)].map((_, i) => (
                  <FaStar key={i} size={18} color="#f6c000" />
                ))}
                {[...Array(5 - rating.rating)].map((_, i) => (
                  <FaRegStar key={i} size={18} color="#f6c000" />
                ))}
              </div>
            </div>
          </div>
        ))}

        {activeTab === "photos" && (
          <div className="card p-3 shadow-sm border-0 mb-3">
            <div className="container p-3">
              <div className="row">
                {photos.map((photo, idx) => (
                  <div className="col-lg-3 col-md-6 col-sm-12 pb-4" key={idx}>
                    <div className="card shadow-sm border-0">
                      <img src={photo.imageUrl} alt={photo.spotName} className="mountain-img rounded-top" />
                      <div className="card-body">
                        <div className="fw-bold text-dark">{photo.spotName}</div>
                        <div className="text-muted small">By: {photo.userName}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .card.p-3.shadow-sm.border-0 {
    background-color: #fafafa !important;
  }

  .mountain-img {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
`;

export default RatingsReviewsTab;